import React from "react";

// Cor determinística a partir do nome (mesmo nome sempre cai na mesma cor),
// não precisa de foto de perfil pra dar identidade visual numa lista de pessoas.
const CORES = ["#0B3DF0", "#7C3AED", "#0891B2", "#059669", "#D97706", "#DC2626", "#BE185D", "#4338CA"];

function corPorNome(nome) {
  let hash = 0;
  for (let i = 0; i < nome.length; i++) hash = (hash * 31 + nome.charCodeAt(i)) >>> 0;
  return CORES[hash % CORES.length];
}

function iniciais(nome) {
  const partes = nome.trim().split(/\s+/).filter(Boolean);
  if (partes.length === 0) return "?";
  if (partes.length === 1) return partes[0].slice(0, 2).toUpperCase();
  return (partes[0][0] + partes[partes.length - 1][0]).toUpperCase();
}

export default function Avatar({ nome = "", size = 32, fontSize }) {
  return (
    <div
      style={{
        width: size,
        height: size,
        borderRadius: "50%",
        background: corPorNome(nome || "?"),
        color: "#fff",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        fontSize: fontSize || Math.round(size * 0.4),
        fontWeight: 700,
        flexShrink: 0,
        letterSpacing: "0.02em",
      }}
    >
      {iniciais(nome)}
    </div>
  );
}
